import { takeEvery, fork, put, all, call } from "redux-saga/effects";

// PredefinedMessages Redux States
import {
  GET_PREDEFINED_MESSAGES,
  GET_PREDEFINED_MESSAGE,
  CREATE_PREDEFINED_MESSAGE,
  EDIT_PREDEFINED_MESSAGE,
  DELETE_PREDEFINED_MESSAGE,
  GET_PREDEFINED_MESSAGES_CONVERSATION,
} from "./actionTypes";
import {
  setPredefinedMessages,
  apiError,
  setPredefinedMessage,
  createPredefinedMessageSuccess,
  editPredefinedMessageSuccess,
  deletePredefinedMessageSuccess,
  getPredefinedMessagesConversationError,
  getPredefinedMessagesConversationSuccess,
} from "./actions";

//Include Both Helper File with needed methods
import axios from "axios";

function* getPredefinedMessages({ payload: { page, qnt, name, skillId } }) {
  try {
    const response = yield call(
      axios.get,
      `/predefined-message?${
        (page ? `page=${page}` : "") +
        (qnt ? `&qtd=${qnt}` : "") +
        (name ? `&title=${name}` : "") +
        (skillId ? `skill_id=${skillId}` : "")
      }`
    );
    if (
      (response.status >= 200 || response.status <= 299) &&
      response.data &&
      response.data.data
    ) {
      yield put(setPredefinedMessages(response.data.data, qnt));
    } else throw response.data;
  } catch (error) {
    let message;
    if (error.response && error.response.status) {
      switch (error.response.status) {
        case 401:
          message = "Invalid credentials";
          break;
        case 404:
          //TODO: remover esta verificação quando o backend enviar array vazio com status 200 quando nao ha objetos
          if (error.response.data && typeof error.response.data === "object") {
            message = error.response.data.message;
          } else {
            message = "Sorry! the page you are looking for could not be found";
          }
          break;
        case 500:
          message =
            "Sorry! something went wrong, please contact our support team";
          break;
        default:
          if (error.response.data && error.response.data.message)
            message = error.response.data.message;
          else message = error.message;
          break;
      }
    }
    yield put(apiError(message));
  }
}

function* createPredefinedMessage({ payload: { newPredefinedMessageValues } }) {
  try {
    const response = yield call(
      axios.post,
      `/predefined-message`,
      newPredefinedMessageValues
    );
    if (response.status >= 200 || response.status <= 299) {
      let message = response.data.message;
      yield put(createPredefinedMessageSuccess(message));
    } else {
      throw response.data;
    }
  } catch (error) {
    let message;
    if (error.response && error.response.status) {
      switch (error.response.status) {
        case 401:
          message = "Invalid credentials";
          break;
        case 404:
          message = "Sorry! the page you are looking for could not be found";
          break;
        case 500:
          message =
            "Sorry! something went wrong, please contact our support team";
          break;
        default:
          if (error.response.data && error.response.data.message)
            message = error.response.data.message;
          else message = error.message;
          break;
      }
    }
    yield put(apiError(message));
  }
}

function* getPredefinedMessage({ payload: { idPredefinedMessage, isForm } }) {
  try {
    const response = yield call(
      axios.get,
      `/predefined-message?${
        (idPredefinedMessage ? `id=${idPredefinedMessage}` : "") +
        (isForm ? `&form=${isForm}` : "")
      }`,
      {}
    );
    if (
      (response.status >= 200 || response.status <= 299) &&
      response.data &&
      response.data.data
    ) {
      yield put(setPredefinedMessage(response.data.data));
    } else throw response.data;
  } catch (error) {
    let message;
    if (error.response && error.response.status) {
      switch (error.response.status) {
        case 401:
          message = "Invalid credentials";
          break;
        case 404:
          message = "Sorry! the page you are looking for could not be found";
          break;
        case 500:
          message =
            "Sorry! something went wrong, please contact our support team";
          break;
        default:
          if (error.response.data && error.response.data.message)
            message = error.response.data.message;
          else message = error.message;
          break;
      }
    }
    yield put(apiError(message));
  }
}
function* editPredefinedMessage({
  payload: { idPredefinedMessage, newPredefinedMessageValues },
}) {
  try {
    const response = yield call(
      axios.patch,
      `/predefined-message?${
        idPredefinedMessage ? `id=${idPredefinedMessage}` : ""
      }`,
      newPredefinedMessageValues
    );
    if (
      (response.status >= 200 || response.status <= 299) &&
      response.data &&
      response.data.message
    ) {
      let message = response.data.message;
      yield put(editPredefinedMessageSuccess(message));
    } else throw response.data;
  } catch (error) {
    let message;
    if (error.response && error.response.status) {
      switch (error.response.status) {
        case 401:
          message = "Invalid credentials";
          break;
        case 404:
          message = "Sorry! the page you are looking for could not be found";
          break;
        case 500:
          message =
            "Sorry! something went wrong, please contact our support team";
          break;
        default:
          if (error.response.data && error.response.data.message)
            message = error.response.data.message;
          else message = error.message;
          break;
      }
    }
    yield put(apiError(message));
  }
}
function* deletePredefinedMessage({ payload: { idPredefinedMessage } }) {
  try {
    const response = yield call(
      axios.delete,
      `/predefined-message${
        idPredefinedMessage ? `?id=${idPredefinedMessage}` : ""
      }`
    );
    if (response.status >= 200 || response.status <= 299) {
      let message = response.data.message ? response.data.message : "";
      yield put(deletePredefinedMessageSuccess(message));
    } else {
      throw response.data;
    }
  } catch (error) {
    let message;
    if (error.response && error.response.status) {
      switch (error.response.status) {
        case 401:
          message = "Invalid credentials";
          break;
        case 404:
          message = "Sorry! the page you are looking for could not be found";
          break;
        case 500:
          message =
            "Sorry! something went wrong, please contact our support team";
          break;
        default:
          if (error.response.data && error.response.data.message)
            message = error.response.data.message;
          else message = error.message;
          break;
      }
    }
    yield put(apiError(message));
  }
}

export function* getPredefinedMessagesConversation({payload}) {
  const skillId = payload.skillId || null;
  try {
    const response = yield call(
      axios.get,
      `${process.env.REACT_APP_MESSAGES_API_URL}/tech4h-messages/conversation/predefined-messages`,
      {
        params: {
          skill_id: skillId,
        },
      }
    );
    if (
      (response.status >= 200 || response.status <= 299) &&
      response.data &&
      response.data.data
    ) {
      yield put(getPredefinedMessagesConversationSuccess(skillId, response.data.data));
    } else throw response.data;
  } catch (error) {
    let message;
    console.log(error);
    if (error.response && error.response.status) {
      switch (error.response.status) {
        case 401:
          message = "Invalid credentials";
          break;
        case 404:
          message = "Sorry! the page you are looking for could not be found";
          break;
        case 500:
          message =
            "Sorry! something went wrong, please contact our support team";
          break;
        default:
          if (error.response.data && error.response.data.message)
            message = error.response.data.message;
          else message = error.message;
          break;
      }
    }
    yield put(getPredefinedMessagesConversationError(skillId));
  }
}

export function* watchPredefinedMessage() {
  yield takeEvery(GET_PREDEFINED_MESSAGES, getPredefinedMessages);
}
export function* watchGetPredefinedMessage() {
  yield takeEvery(GET_PREDEFINED_MESSAGE, getPredefinedMessage);
}
export function* watchCreatePredefinedMessage() {
  yield takeEvery(CREATE_PREDEFINED_MESSAGE, createPredefinedMessage);
}
export function* watchEditPredefinedMessage() {
  yield takeEvery(EDIT_PREDEFINED_MESSAGE, editPredefinedMessage);
}
export function* watchDeletePredefinedMessage() {
  yield takeEvery(DELETE_PREDEFINED_MESSAGE, deletePredefinedMessage);
}
export function* watchGetPredefinedMessagesConversation() {
  yield takeEvery(
    GET_PREDEFINED_MESSAGES_CONVERSATION,
    getPredefinedMessagesConversation
  );
}
function* authSaga() {
  yield all([
    fork(watchPredefinedMessage),
    fork(watchGetPredefinedMessage),
    fork(watchCreatePredefinedMessage),
    fork(watchEditPredefinedMessage),
    fork(watchDeletePredefinedMessage),
    fork(watchGetPredefinedMessagesConversation),
  ]);
}

export default authSaga;
